<template>
  <div
    id="seasidetms_row_kxt9n4g3jg"
    class="seasidetms_row seasidetms_color_scheme_default seasidetms_row_top_default seasidetms_row_bot_default seasidetms_row_boxed"
  >
    <div class="seasidetms_row_outer_parent features">
      <div class="seasidetms_row_outer">
        <div class="seasidetms_row_inner">
          <div class="seasidetms_row_margin seasidetms_14141414">
            <div
              id="seasidetms_column_ozo33evnvn"
              class="seasidetms_column one_fourth fadeInRight animated"
              v-wow="{
                'animation-name': 'fadeInUp',
                'animation-duration': '1s',
              }"
            >
              <div class="seasidetms_column_inner">
                <div
                  id="seasidetms_icon_box_bhmm1n0jz"
                  class="seasidetms_icon_box seasidetms_icon_box_left box_icon_type_icon seasidetms-icon-rocket shortcode_animated"
                >
                  <div class="icon_box_inner">
                    <div class="h6 icon_box_heading">
                      {{ $t('home.features.delivery') }}
                    </div>
                    <div class="icon_box_text">
                      <p></p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              id="seasidetms_column_18u05ab54e"
              class="seasidetms_column one_fourth fadeInRight animated"
            >
              <div class="seasidetms_column_inner">
                <div
                  id="seasidetms_icon_box_jrtkdmbtc"
                  class="seasidetms_icon_box seasidetms_icon_box_left box_icon_type_icon seasidetms-icon-ok shortcode_animated"
                >
                  <div class="icon_box_inner">
                    <div class="h6 icon_box_heading">
                      {{ $t('home.features.payment') }}
                    </div>
                    <div class="icon_box_text">
                      <p></p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              id="seasidetms_column_me1mh73own"
              class="seasidetms_column one_fourth fadeInRight animated"
            >
              <div class="seasidetms_column_inner">
                <div
                  id="seasidetms_icon_box_u88m33q15"
                  class="seasidetms_icon_box seasidetms_icon_box_left box_icon_type_icon seasidetms-icon-direction shortcode_animated"
                >
                  <div class="icon_box_inner">
                    <div class="h6 icon_box_heading">
                      {{ $t('home.features.online') }}
                    </div>
                    <div class="icon_box_text">
                      <p></p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              id="seasidetms_column_bw6enst3q4"
              class="seasidetms_column one_fourth fadeInRight animated"
            >
              <div class="seasidetms_column_inner">
                <div
                  id="seasidetms_icon_box_u88m33q15"
                  class="seasidetms_icon_box seasidetms_icon_box_left box_icon_type_icon seasidetms-icon-tablet shortcode_animated"
                >
                  <div class="icon_box_inner">
                    <div class="h6 icon_box_heading">
                      {{ $t('home.features.new-used') }}
                    </div>
                    <div class="icon_box_text">
                      <p></p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <router-link
              tag="div"
              :to="`${
                $store.state.lang ? `/${$store.state.lang}` : ''
              }/service`"
              class="seasidetms_column one_fourth fadeInRight animated seasidetms_column--repair"
            >
              <div class="seasidetms_column_inner">
                <div
                  id="seasidetms_icon_box_u88m33q15"
                  class="seasidetms_icon_box seasidetms_icon_box_left box_icon_type_icon seasidetms-icon-custom-settings shortcode_animated"
                >
                  <div class="icon_box_inner">
                    <div class="h6 icon_box_heading">
                      {{ $t('repairHome') }}
                    </div>
                    <div class="icon_box_text">
                      <p></p>
                    </div>
                  </div>
                </div>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Features',
}
</script>

<style>
@media only screen and (min-width: 450px) {
  .features .seasidetms_column.seasidetms_column--repair {
    display: none;
  }
}
</style>
